import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { AddReceiverComponent } from './components/add-receiver/add-receiver.component';
import { ViewEditReceiverComponent } from './components/view-edit-receiver/view-edit-receiver.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { ResetPasswordModalComponent } from './components/reset-password-modal/reset-password-modal.component';
import { DriversTrackingMapComponent } from '@shared-features/components/drivers-tracking-map/drivers-tracking-map.component';
import { ShipmentStatusLabelComponent } from '@shared-features/components/shipment-status-label/shipment-status-label.component';
import { DeliveryNoteModalComponent } from '@shared-features/components/delivery-note-modal/delivery-note-modal.component';
import { PermitAccessControlListComponent } from './components/permit-access-control-list/permit-access-control-list.component';
import { PermitAccessControlComponent } from './components/permit-access-control/permit-access-control.component';
import { PermittedAccessListComponent } from './components/permitted-access-list/permitted-access-list.component';
import { GateToGateComponent } from '@shared-features/components/gate-to-gate/gate-to-gate.component';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { LocationsComponent } from './components/locations/locations.component';
import { AddLocationComponent } from './components/add-location/add-location.component';
import { LocationsListComponent } from './components/locations-list/locations-list.component';
import { ShipmentSmartDetectionComponent } from '@shared-features/components/shipment-smart-detection/shipment-smart-detection.component';
import { ShipmentDetectionTabComponent } from './components/shipment-detection-tab/shipment-detection-tab.component';
import { ShipmentAssignmentAction } from './components/shipment-assignment-action/shipment-assignment-action.component';
import { PlateNumberViewComponent } from '@shared-features/components/plate-number-view/plate-number-view.component';
import { ShippingCardComponent } from '@shared-features/components/shipping-card/shipping-card.component';
import { NewGateToGateComponent } from '@shared-features/components/new-gate-to-gate/new-gate-to-gate.component';
import { PreviewMapComponent } from '@shared-features/components/preview-map/preview-map.component';
import { PaymentsListComponent } from './components/payments-list/payments-list.component';
import { PaymentShipmentsComponent } from './components/payment-shipments/payment-shipments.component';
import { PaymentConfirmationModalComponent } from '@features/transportation-payments/components/payment-confirmation-modal/payment-confirmation-modal.component';
import { MarkPaymentModalComponent } from '@features/transportation-payments/components/mark-payment-modal/mark-payment-modal.component';
import { DashboardCardComponent } from './components/dashboard-card/dashboard-card.component';
import { StatsCardDashboardComponent } from './components/stats-card/stats-card-dashboard.component';
import { EditGateToGateDialogComponent } from './components/edit-gate-to-gate-dialog/edit-gate-to-gate-dialog.component';
import { LanguageService } from '@shared/services/language.service';
import i18n from './i18n';
import { GateDefinitionComponent } from './components/gate-definition/gate-definition.component';
import { GateToGateTimelineComponent } from './components/gate-to-gate-timeline/gate-to-gate-timeline.component';
import { AvlOverSpeedMarkerComponent } from '@shared-features/components/avl-over-speed-marker/avl-over-speed-marker.component';
import { ShipmentTrackingMapComponent } from '@shared-features/components/shipment-tracking-map/shipment-tracking-map.component';
import { ShipmentStopMarkerComponent } from '@shared-features/components/shipment-stop-marker/shipment-stop-marker.component';
import { ElmDataModalComponent } from './components/elm-data-modal/elm-data-modal.component';
import { TruckElmDataModalComponent } from './components/truck-elm-data-modal/truck-elm-data-modal.component';
import { ShipmentAssignmentActionWrapperComponent } from './components/shipment-assignment-action-wrapper/shipment-assignment-action-wrapper.component';
import { MapElementDirective } from './directives/map-element.directive';
import { CementInfoComponent } from '@shared-features/components/cement-info/cement-info.component';
import { IntegrationCardComponent } from '@shared-features/components/integration-card/integration-card.component';
import { OrdersListTimelineComponent } from './components/orders-list-timeline/orders-list-timeline.component';
import { OrdersListItemComponent } from '@shared-features/components/orders-list-item/orders-list-item.component';
import { AnalyticsCardComponent } from '@shared-features/components/analytics-card/analytics-card.component';
import { AiDrawerComponent } from './components/ai-drawer/ai-drawer.component';
import { AutoGrowHeightDirective } from './directives/auto-grow-height.directive';
import { PricingMethodComponent } from './components/pricing-method/pricing-method.component';
import { ZeroShipmentPricesComponent } from './components/zero-shipment-prices/zero-shipment-prices.component';
import { InvoiceTypeFeesComponent } from './components/invoice-type-fees/invoice-type-fees.component';
import { WaitingChargeConfigComponent } from './components/waiting-charge-config/waiting-charge-config.component';
import { B2cRedirectPageComponent } from './components/b2c-redirect-page/b2c-redirect-page.component';
import { PasswordExpiryDialogComponent } from './components/password-expiry-dialog/password-expiry-dialog.component';
import { AccountStatementsComponent } from './components/account-statements/account-statements.component';

const COMPONENTS = [
  AddReceiverComponent,
  ViewEditReceiverComponent,
  AddUserComponent,
  UsersListComponent,
  ResetPasswordModalComponent,
  DriversTrackingMapComponent,
  ShipmentStatusLabelComponent,
  DeliveryNoteModalComponent,
  PermitAccessControlListComponent,
  PermitAccessControlComponent,
  PermittedAccessListComponent,
  GateToGateComponent,
  AuditTrailComponent,
  UserFormComponent,
  LocationsComponent,
  AddLocationComponent,
  LocationsListComponent,
  ShipmentSmartDetectionComponent,
  ShipmentDetectionTabComponent,
  ShipmentAssignmentAction,
  PlateNumberViewComponent,
  ShippingCardComponent,
  NewGateToGateComponent,
  PreviewMapComponent,
  PaymentsListComponent,
  PaymentShipmentsComponent,
  PaymentConfirmationModalComponent,
  MarkPaymentModalComponent,
  DashboardCardComponent,
  StatsCardDashboardComponent,
  EditGateToGateDialogComponent,
  GateDefinitionComponent,
  AvlOverSpeedMarkerComponent,
  GateToGateTimelineComponent,
  ShipmentTrackingMapComponent,
  ShipmentStopMarkerComponent,
  ElmDataModalComponent,
  TruckElmDataModalComponent,
  ShipmentAssignmentActionWrapperComponent,

  CementInfoComponent,
  IntegrationCardComponent,
  OrdersListTimelineComponent,
  OrdersListItemComponent,
  AnalyticsCardComponent,
  AiDrawerComponent,
  PricingMethodComponent,
  ZeroShipmentPricesComponent,
  InvoiceTypeFeesComponent,
  WaitingChargeConfigComponent,
  B2cRedirectPageComponent,
  PasswordExpiryDialogComponent,
  AccountStatementsComponent,
];

const DIRECTIVES = [MapElementDirective, AutoGrowHeightDirective];
@NgModule({
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS],
  imports: [CommonModule, SharedModule],
})
export class SharedFeaturesModule {
  constructor(languageService: LanguageService) {
    languageService.registerModule(i18n);
  }
}
